import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { selectSponsorshipFirstName, selectSponsorshipPhotoUri } from '../../../../store/selectors/sponsorship'
import { Text, Button } from '../../..'
import QuestionSingle from '../../../shared/Questions/QuestionSingleContainer'

// Constants
import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'

// Styles
import styles from './RefiRateRequestPanel.module.scss'

const messages = defineMessages({
  successPlaceholder: {
    id: 'RefiRequestSuccess.question.placeholder',
    defaultMessage: 'Send {firstName} a quick note...'
  }
})

const RefiRateRequestPanelSuccess = ({ doSubmit }) => {
  const intl = useIntl()
  const sponsorFirstName = useSelector(selectSponsorshipFirstName)
  const sponsorPhotoUri = useSelector(selectSponsorshipPhotoUri)

  return (
    <>
      <span className={styles.emoji} role='img' aria-label='Success!'>
        🎉
      </span>
      <Text size='xl' className={styles.title} variant='neutralCool' variantCount='900'>
        <FormattedMessage
          id='RefiRateRequestPanelSuccess.title'
          defaultMessage='Hang tight! {firstName} will be in touch soon.'
          values={{ firstName: sponsorFirstName }}
        />
      </Text>
      <QuestionSingle
        className={styles.dm}
        questionTopic={CUSTOMER_MESSAGES.REFINANCING.topic}
        questionTopicKey={CUSTOMER_MESSAGES.REFINANCING.topicKey}
        placeholder={intl.formatMessage(messages.successPlaceholder, {
          firstName: sponsorFirstName
        })}
        avatarUri={sponsorPhotoUri}
      />
      <Button className={styles.backButton} onClick={doSubmit}>
        <FormattedMessage id='RefiRateRequestPanelSuccess.button' defaultMessage='Sounds good' />
      </Button>
    </>
  )
}

RefiRateRequestPanelSuccess.propTypes = {
  doSubmit: PropTypes.func.isRequired
}

export default RefiRateRequestPanelSuccess
